

import "../../Foundation/stylable/colors.st.css.js";
import "../../common/Focusable/Focusable.st.css.js";
import "../../Tooltip/Tooltip.st.css.js";
import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_3_ToggleIcon";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_3_ToggleIcon__root","tooltip":"wds_1_220_3_ToggleIcon__tooltip","button":"wds_1_220_3_ToggleIcon__button","textWrapper":"wds_1_220_3_ToggleIcon__textWrapper"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-segmented-toggle-icononly-padding-horizontal-small":"--wds-segmented-toggle-icononly-padding-horizontal-small","wds-segmented-toggle-icononly-padding-horizontal-medium":"--wds-segmented-toggle-icononly-padding-horizontal-medium","wds-segmented-toggle-icononly-padding-vertical-small":"--wds-segmented-toggle-icononly-padding-vertical-small","wds-segmented-toggle-icononly-padding-vertical-medium":"--wds-segmented-toggle-icononly-padding-vertical-medium","wds-segmented-toggle-border-radius-small":"--wds-segmented-toggle-border-radius-small","wds-segmented-toggle-border-radius-medium":"--wds-segmented-toggle-border-radius-medium","wds-shadow-focus-standard":"--wds-shadow-focus-standard","wds-segmented-toggle-border-width-default":"--wds-segmented-toggle-border-width-default","wds-segmented-toggle-border-width-selected":"--wds-segmented-toggle-border-width-selected","wds-segmented-toggle-size-small":"--wds-segmented-toggle-size-small","wds-segmented-toggle-border-width":"--wds-segmented-toggle-border-width","wds-segmented-toggle-size-medium":"--wds-segmented-toggle-size-medium"}; 




